import { isNotBlank } from '@app/utils/string';

interface FileCheckerOptions {
  accept?: string;
  maxFileSize?: number;
}

interface FileCheckResult {
  acceptedFiles: File[];
  rejectedFiles: RejectedFile[];
}

export interface RejectedFile {
  file: File;
  reason: 'maxFileSize' | 'accept';
}

export interface RejectedFiles {
  accept?: string;
  files: RejectedFile[];
  maxFileSize?: number;
}

export class FileChecker {
  private accept?: string;
  private maxFileSize?: number;

  constructor({ accept, maxFileSize }: FileCheckerOptions = {}) {
    this.accept = accept;
    this.maxFileSize = maxFileSize;
  }

  setMaxFileSize(size: number): void {
    this.maxFileSize = size;
  }

  check(files: FileList | File[]): FileCheckResult {
    if (this.accept == null && this.maxFileSize == null) {
      return {
        acceptedFiles: Array.from(files),
        rejectedFiles: [],
      };
    }

    const acceptedFiles: File[] = [];
    const rejectedFiles: RejectedFile[] = [];

    for (const file of files) {
      if (this.exceedsSize(file)) {
        rejectedFiles.push({
          file,
          reason: 'maxFileSize',
        });
      } else if (this.isAllowed(file) === false) {
        rejectedFiles.push({
          file,
          reason: 'accept',
        });
      } else {
        acceptedFiles.push(file);
      }
    }

    return {
      acceptedFiles,
      rejectedFiles,
    };
  }

  private exceedsSize(file: File): boolean {
    return this.maxFileSize != null && file.size >= this.maxFileSize;
  }

  private isAllowed(file: File): boolean {
    let isAllowed = true;

    let accept: RegExp[];

    if (isNotBlank(this.accept)) {
      accept = this.accept.split(',').map((accept) => new RegExp(accept.replace('*', '.+')));
    } else {
      accept = [];
    }

    if (accept.length > 0) {
      isAllowed = accept.some((regex) => regex.test(file.type));
    }

    return isAllowed;
  }
}
